<template>
	<div class="signature-wrap">
		<div class="sig-header" v-if="installState&&browerState&&type!=3">
			<div class="sig-header-lt">
				<span v-if="type==0||type==2">
						<div class="sig-btn" @click="predeal('handStamp')">
							<div class="sig-btn-icon">
								<i class="epfont ep-icon-gaizhang"></i>
							</div>
							<div class="sig-btn-name">盖章</div>
						</div>
						<div class="sig-btn" @click="predeal('qiFengSeal')">
							<div class="sig-btn-icon">
								<i class="epfont ep-icon-qifengzhang"></i>
							</div>
							<div class="sig-btn-name">骑缝</div>
						</div>
					</span>
				<div class="sig-btn-ipt" v-if="type==0||type==1">
					<div class="sig-btn-lt" @click="predeal('handwrite')">
						<div class="sig-btn-icon">
							<i class="epfont ep-icon-bianji"></i>
						</div>
						<div class="sig-btn-name">签名</div>
					</div>
					<div class="sig-btn-rt" @click="penColor">
						<i class="epfont ep-icon-banshou"></i>
					</div>
				</div>
				<div class="sig-btn  sig-btn-upload" @click="predeal('upload')">
					<div class="sig-btn-icon">
						<i class="epfont ep-icon-group8"></i>
					</div>
					<div class="sig-btn-name">提交</div>
				</div>
				<div :class="['sig-btn-giveup', {'give-up-active':giveState}]" @click="giveUp">
					<div class="sig-btn-icon">
						<i class="epfont ep-icon-quxiao"></i>
					</div>
					<div class="sig-btn-name">取消</div>
				</div>
			</div>
			<div class="sig-header-rt">
<!-- 				<div class="sig-btn" @click="loadFile">
					<div class="sig-btn-icon">
						<i class="epfont ep-icon-shangchuan1"></i>
					</div>
					<div class="sig-btn-name">上传</div>
				</div> -->
				<div class="sig-btn" @click="pageNumber+=20">
					<div class="sig-btn-icon">
						<i class="epfont ep-icon-fangda"></i>
					</div>
					<div class="sig-btn-name">放大</div>
				</div>
				<div class="sig-btn" @click="pageNumber-=20">
					<div class="sig-btn-icon">
						<i class="epfont ep-icon-suoxiao"></i>
					</div>
					<div class="sig-btn-name">缩小</div>
				</div>
				<div class="sig-btn" @click="undo">
					<div class="sig-btn-icon">
						<i class="epfont ep-icon-fanhui"></i>
					</div>
					<div class="sig-btn-name">撤销</div>
				</div>
				<div class="sig-btn" @click="redo">
					<div class="sig-btn-icon">
						<i class="epfont ep-icon-chexiao"></i>
					</div>
					<div class="sig-btn-name">恢复</div>
				</div>
				<div class="sig-btn" @click="predeal('printDoc')">
					<div class="sig-btn-icon">
						<i class="epfont ep-icon-ccgl-dayinliebiao-3"></i>
					</div>
					<div class="sig-btn-name">打印</div>
				</div>
				<div class="sig-btn" @click="clearAll">
					<div class="sig-btn-icon">
						<i class="epfont ep-icon-shanchu"></i>
					</div>
					<div class="sig-btn-name">清空</div>
				</div>
			</div>
		</div>
		<div class="sig-header sig-install" v-if="!installState&&browerState">
			<div class="sig-btn" @click="controlInstall" style="float: right;">
				<div class="sig-btn-icon">
					<i class="epfont ep-icon-xiazai"></i>
				</div>
				<div class="sig-btn-name">控件安装</div>
			</div>
		</div>
		<div class="sig-header" v-if="!browerState">
			<div class="sig-other-brower">
				签字盖章操作仅支持在IE浏览器，请切换浏览器再进行此操作！
			</div>
		</div>
		<div class="sig-content">
			<object id="HWPostil1" align="middle" style="width:100%;height:100%" classid="clsid:FF1FE7A0-0578-4FEE-A34E-FB21B277D561"
			 codebase="HWPostil.cab#version=3,0,6,6">
					<param name="_Version" value="65536">
					<param name="_ExtentX" value="17410">
					<param name="_ExtentY" value="10874">
					<param name="_StockProps" value="0">
				</object>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ep-signature',
		data() {
			return {
				isSignature: false,
				signatureObj: null,
				pageNumber: 100,
				installState: false,
				browerState: true,
				giveState: false
			}
		},
		props: {
			src: {
				type: String,
				default: ''
			},
			type: {
				type: Number,
				default: 0
			},
			action: {
				type: String,
				default: ''
			},
			params: {
				type: Object,
				default: {}
			},
			update: {
				type: String,
				// default: 'http://oozssitny.bkt.clouddn.com/%E8%BD%AF%E4%BB%B6%E5%AE%89%E8%A3%85.zip'
				default: 'http://oozssitny.bkt.clouddn.com/%E6%8E%A7%E4%BB%B6%E5%AE%89%E8%A3%85%E5%8C%85.rar'
			}
		},
		mounted() {
			if (this.isIE()) {
				this.initSignature()
				return
			}
			this.browerState = false
		},
		watch: {
			src() {
				if (this.isIE()) {
					this.loadOriginFile()
				}
			},
			pageNumber() {
				this.setPageMode()
			}
		},
		methods: {
			// 初始化方法
			initSignature() {
				this.signatureObj = document.getElementById('HWPostil1')
				if (this.isInstall()) {
					try {
						this.installState = true
						this.signatureObj.SilentMode = 1 // 设置为安静模式 
						this.signatureObj.ShowDefMenu = false // 隐藏菜单
						this.signatureObj.ShowToolBar = false; // 隐藏工具条 
						this.signatureObj.ShowScrollBarButton = 1 // 隐藏滚动条上的控制菜单
						// this.signatureObj.Login('aip', 1, 32767, '1111', '') // 本地智能用户登录
						this.signatureObj.Login('HWSEALDEMO**', 4, 32767, 'DEMO', '');//4：测试用户
						this.isSignature = true
						this.loadOriginFile()
						// this.signatureObj.attachEvent('NotifyChangePenColor', () => {
						// 	alert(66)
						// })
					} catch (error) {
						console.log('请使用IE进行当前操作')
					}
					return
				}
				this.publishError('请先成功安装控件之后再执行此操纵')
			},
			//			操作预处理
			predeal(name) {
				if (!this.isOpen()) {
					this.publishError('请先成功打开文件之后再执行此操纵')
					return
				}
				if (!this.isLogin()) {
					this.signatureObj.Login('aip', 1, 32767, '1111', '')
					if (!this.isLogin()) {
						this.publishError('请插入UKEY授权之后再执行此操纵')
						return
					}
					this.publishSuccess('用户授权成功')
				}
				if (this[name]) {
					this[name]()
					if (name == 'printDoc' || name == 'upload') return
					this.giveState = true
				}
			},
			// 控件是否安装
			isInstall() {
				return !!this.signatureObj.ShowDefMenu
			},
			// 控件下载
			controlInstall() {
				window.location.href = this.update
			},
			// 加载本地文件
			loadFile() {
				this.signatureObj.LoadFile('')
			},
			// 加载远程文件
			loadOriginFile() {
				if (this.src != '') {
					this.signatureObj.CloseDoc(0);
					this.signatureObj.LoadFile(this.src)
				}
			},
			// 保存文件
			saveFile() {
				this.signatureObj.SaveTo('', '', 0)
			},
			//		拖动文档
			giveUp() {
				this.signatureObj.CurrAction = 1
				this.giveState = false
			},
			// 签字操作
			handwrite() {
				this.signatureObj.CurrAction = 264
			},
			// 骑缝章
			qiFengSeal() {
				let num = this.signatureObj.PageCount;
				let page = ''
				let model = 0
				for (let i = 1; i < num; i++) {
					page += i + ',';
				}
				num <= 1 ? model = 0 : model = 1;
				let sealin = 100 / num;
				this.signatureObj.AddQiFengSeal(0, `0,25000,${model},3,${sealin},${page}`, '', 'AUTO_ADD_SEAL_FROM_PATH')
			},
			// 盖章操作
			handStamp() {
				this.signatureObj.CurrAction = 2568
			},
			// 撤销
			undo() {
				this.signatureObj.Undo();
			},
			// 恢复
			redo() {
				this.signatureObj.redo();
			},
			// 清空全部操作
			clearAll() {
				this.signatureObj.UndoAll();
			},
			// 笔迹设置
			penColor() {
				this.signatureObj.CurrPenColor = -1
			},
			// 上传当前文件
			upload() {
				if (this.action == '') {
					this.publishError('请配置文件上传地址')
					return
				}
				this.signatureObj.HttpInit();
				if (typeof this.params == 'object') {
					for (let m in this.params) {
						this.signatureObj.HttpAddPostString(m, this.params[m])
					}
				}
				this.signatureObj.HttpAddPostCurrFile('file');
				let state = this.signatureObj.HttpPost(this.action);
				let reg = /^[failed]+/
				if (reg.test(state)) {
					this.publishUpload(false, {})
					this.publishError('文件上传失败')
					return
				}
				this.publishUpload(true, state)
				this.publishSuccess('文件上传成功')
			},
			// 判断是否登录
			isLogin() {
				let state = this.signatureObj.IsLogin();
				return !!state
			},
			// 判断是否打开文件
			isOpen() {
				let state = this.signatureObj.IsOpened()
				return !!state
			},
			// 打印文档
			printDoc() {
				this.signatureObj.PrintDoc(1, 1);
			},
			// 文件缩放
			setPageMode() {
				let num = this.pageNumber < 10 ? this.pageNumber = 10 : this.pageNumber
				this.signatureObj.SetPageMode(1, num);
			},
			// 控件是否准备完毕
			isReady() {
				let state = this.signatureObj.IsOpening();
				state ? alert('控件准备完毕') : alert(state)
			},
			// 判断当前是否是IE
			isIE() {
				const bType = {
					isIE11(userAgent) {
						return (userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11') > -1) ? true : false;
					},
					isIE8(userAgent) {
						return (userAgent.indexOf('MSIE') > -1 && userAgent.indexOf('Trident') > -1) ? true : false;
					},
					isIE6(userAgent) {
						return (userAgent.indexOf('MSIE') > -1) ? true : false;
					}
				}
				let userAgent = navigator.userAgent
				return bType.isIE11(userAgent) || bType.isIE8(userAgent) || bType.isIE6(userAgent) ? true : false;
			},
			// 发布错误信息
			publishError(msg) {
				this.$emit('error', msg)
			},
			// 发布成功信息
			publishSuccess(msg) {
				this.$emit('success', msg)
			},
			// 发布文件上传状态
			publishUpload(type, data) {
				let result = {
					status: type,
					data: data
				}
				this.$emit('result', result)
			}

		}
	}

</script>

<style lang="css" scoped>
	.signature-wrap {
		width: 100%;
		height: 100%;
		min-width: 540px;
		box-sizing: border-box;
		padding: 10px;
		position: relative;
		background: #fff;
		overflow: hidden;
	}

	.sig-header {
		width: 100%;
		height: 50px;
		display: inline-flex;
		margin-bottom: 10px;
	}

	.sig-other-brower {
		width: 100%;
		line-height: 80px;
		font-size: 16px;
		color: #FF4949;
		text-align: center;
	}

	.sig-content {
		width: 100%;
		height: calc(100% - 60px);
		/* border: 1px solid red; */
	}

	.sig-header-lt {
		width: auto;
		border-right: 1px solid #DCDCDC;
		text-align: left;
		padding-right: 20px;
	}

	.sig-header-rt {
		flex: 1;
		text-align: right;
	}

	.sig-btn {
		width: 50px;
		height: 50px;
		display: inline-block;
		text-align: center;
		cursor: pointer;
		position: relative;
	}

	.sig-btn:hover {
		color: #20A0FF;
	}

	.sig-btn-giveup {
		width: auto;
		height: 50px;
		text-align: center;
		display: inline-block;
		position: relative;
		cursor: pointer;
		color: #DCDCDC;
	}

	.give-up-active {
		color: #2c3e50;
	}

	.give-up-active:hover {
		color: #20A0FF;
	}

	.sig-btn-ipt {
		width: 60px;
		height: 50px;
		display: inline-block;
		cursor: pointer;
		position: relative;
		vertical-align: top;
		text-align: left;
		margin-left: 10px;
	}

	.sig-btn-lt {
		display: inline-block;
		width: 30px;
		/*border: 1px solid red;*/
		position: relative;
		height: 100%;
		vertical-align: top;
		text-align: center;
	}

	.sig-btn-lt:hover {
		color: #20A0FF;
	}

	.sig-btn-rt:hover {
		color: #20A0FF;
	}

	.sig-btn-rt {
		display: inline-block;
		width: 20px;
		height: 100%;
		line-height: 50px;
		vertical-align: top;
		display: none;
		/*border: 1px solid red;*/
	}

	.sig-btn-ipt:hover .sig-btn-rt {
		display: inline-block;
	}

	.sig-btn-icon {
		width: 100%;
		height: 30px;
		line-height: 30px;
	}

	.sig-btn-name {
		width: 100%;
		height: 20px;
		line-height: 20px;
		font-size: 12px;
	}

	.sig-install {
		text-align: right;
	}

	.sig-btn-upload {
		color: #00cf6b;
	}

	.sig-btn-upload:hover {
		color: #2F9833;
	}
	/* 引入字体图标 */

	@font-face {
		font-family: "iexplore-icon";
		src:url('../static/fonts/iexplore-icon.woff?t=1554454545415') format("woff"),url('../static/fonts/iexplore-icon.ttf?t=158548454647854') format("truetype");
		/* iOS 4.1- */
	}

	.epfont {
		font-family: "iexplore-icon" !important;
		font-size: 16px;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.ep-icon-gaizhang:before {
		content: "\e600";
	}

	.ep-icon-quxiao:before {
		content: "\e662";
	}

	.ep-icon-banshou:before {
		content: "\e65c";
	}

	.ep-icon-group8:before {
		content: "\e60f";
	}

	.ep-icon-fanhui:before {
		content: "\e628";
	}

	.ep-icon-shanchu:before {
		content: "\e62a";
	}

	.ep-icon-bianji:before {
		content: "\e62c";
	}

	.ep-icon-xiazai:before {
		content: "\e636";
	}

	.ep-icon-xiazai1-copy-copy:before {
		content: "\e601";
	}

	.ep-icon-shangchuan1:before {
		content: "\e63e";
	}

	.ep-icon-ccgl-dayinliebiao-3:before {
		content: "\e602";
	}

	.ep-icon-shangbaodanwei:before {
		content: "\e603";
	}

	.ep-icon-yuanxinxi:before {
		content: "\e604";
	}

	.ep-icon-wancheng:before {
		content: "\e605";
	}

	.ep-icon-shenhe:before {
		content: "\e606";
	}

	.ep-icon-shangchuan:before {
		content: "\e607";
	}

	.ep-icon-chexiao:before {
		content: "\e608";
	}

	.ep-icon-suoxiao:before {
		content: "\e609";
	}

	.ep-icon-fangda:before {
		content: "\e60a";
	}

	.ep-icon-qifengzhang:before {
		content: "\e60b";
	}
</style>


// WEBPACK FOOTER //
// Signature.vue?49f5b069